import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerMediaCacheServiceWorker } from '@/core/registerMediaCacheSw';
import '@/styles/global.css';

registerMediaCacheServiceWorker();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
